{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.hippach.softline",
  "name": "Softline"
}
